import { CheckIcon } from '@heroicons/react/24/outline'

import { anim, prog, stagger } from '../../../../motion'
import { Line } from '../../../../v2/kit'
import { useCopy } from '../../../i18n'
import { MaskText, Odometer } from '../../stage/fx'

// Die Grenze zwischen Chaos (rechts) und Ordnung (links) wandert durchs Bild.
// Partikel und Text wechseln an derselben Kante, deshalb dieselbe Spanne.
const WIPE = [0.14, 0.62]

export const LEVER_PARTICLES = [
  [0, () => ({ type: 'chaosOrder', at: WIPE })],
  [0.66, () => ({ type: 'chaosOrder', at: WIPE })],
  [0.78, () => ({ type: 'chaosOrder', at: WIPE, opacity: 0.32 })]
]

export default function DmsLever() {
  const c = useCopy('hebel')
  const s = useCopy('show')

  return (
    <div className='sc-full'>
      <div className='dms-lever-head'>
        <Line at={[0, 0.05]} className='sc-eyebrow'>
          {c.eyebrow}
        </Line>
        <div className='dms-swap'>
          <div className='sc-h3'>
            <MaskText text={c.before} at={[0.02, 0.1]} out={[0.6, 0.64]} />
          </div>
          <div className='sc-h2 sc-grad'>
            <MaskText text={s.order} at={[0.64, 0.72]} />
          </div>
        </div>
      </div>

      <div
        className='dms-wipe'
        style={{
          ...prog(WIPE),
          ...anim({ at: [0.06, 0.12], out: [0.62, 0.68], y: 30, oy: -30 })
        }}
      >
        <div className='dms-wipe__legend'>
          <span className='dms-wipe__with'>{c.with}</span>
          <span className='dms-wipe__without'>{c.without}</span>
        </div>
        {c.rows.map(([before, after]) => (
          <div key={before} className='dms-wipe__row'>
            <span className='dms-wipe__old'>{before}</span>
            <span className='dms-wipe__new' aria-hidden='true'>
              <CheckIcon className='dms-wipe__check' />
              {after}
            </span>
          </div>
        ))}
        <div className='dms-wipe__edge'>
          <span>Aivy</span>
        </div>
      </div>

      <div className='dms-proof'>
        {c.proof.map((p, i) => (
          <div
            key={p.source}
            className='dms-proof__item'
            style={anim({ at: stagger(0.72, 0.05, 0.08, i), y: 50 })}
          >
            <Odometer
              value={s.proofs[i]}
              at={stagger(0.73, 0.04, 0.1, i)}
              className='sc-num dms-proof__num'
            />
            <div className='dms-proof__label'>{p.label}</div>
            <div className='dms-proof__source'>{p.source}</div>
          </div>
        ))}
      </div>
    </div>
  )
}
